import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Data/Carts/Handlers/AddCartLines";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { setGA4Event } from "@tggstore/Handlers/Utilities/CustomTracking";
import { getProductCategories } from "@tggstore/Services/CommonServices";
import { CustomState } from "@tggstore/Store/Reducers";

addToChainAfter(chain, ExecuteOnSuccessCallback, async props => {
    if (props.apiResult) {
        const cartLines = props.apiResult.cartLines ?? [];
        const cartLinesParameters = props.apiParameter.cartLineCollection.cartLines ?? [];

        cartLines.forEach(cartLine => {
            const auxLine = cartLinesParameters.find(line => line.productId === cartLine.productId);
            if (auxLine && auxLine.qtyOrdered !== cartLine.qtyOrdered) {
                cartLine.qtyOrdered = auxLine.qtyOrdered;
            }
        });

        const state = props.getState() as CustomState;
        const session = props.getState().context.session;
        const billToCustomerName = getBillToState(state, session.billToId)?.value?.customerNumber ?? "";
        const affiliation = state.customDefaultWarehouse.warehouse?.description || "";
        const page = getCurrentPage(state);

        const currency = session?.currency?.currencyCode || "";

        const totalPrice = parseFloat(
            cartLines
                .reduce((acc, cartLine) => {
                    const price = (cartLine.pricing?.actualPrice ?? 0) * (cartLine.qtyOrdered ?? 0);
                    return acc + price;
                }, 0)
                .toFixed(2),
        );

        const productIds = cartLines.map(p => p.productId).filter(id => id !== null && id !== undefined) as string[];

        await getProductCategories({
            productIds,
            type: "product",
        }).then((data: any) => {
            const productCategories = data.result;
            setGA4Event(cartLines, "add_to_cart", {
                currency,
                affiliation,
                account_number: billToCustomerName,
                value: totalPrice,
                productCategories,
                a2c_method: `${page ? page.name : ""} Page`,
            });
        });
    }
});
